(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('AutomaticDistributionController', AutomaticDistributionController);

  AutomaticDistributionController.$inject = ['$state', '$rootScope', 'CompanyService', 'NotificationFactory', 'NotificationService', 'AutomaticDistributionService'];

  function AutomaticDistributionController ($state, $rootScope, CompanyService, NotificationFactory, NotificationService, AutomaticDistributionService) {
    var vm = this;

    vm.save = save;
    vm.company_id = $rootScope.user_data.company_id;
    vm.metadata = $rootScope.company_metadata;

    AutomaticDistributionService
      .find()
      .$promise
      .then(function (data) {
        vm.option_not_counting = '0';
        if (data.allow_if_answered) {
          vm.option_not_counting = '1';
        } else if (data.allow_if_client_not_respond) {
          vm.option_not_counting = '2';
        }
        vm.auto_dist = data;
      })
      .catch(function (data) {
        NotificationService.errorHandler(null, $rootScope.labels.errorLoadDist);
      });

    function verifyOptionNotCounting () {
      vm.auto_dist.allow_if_answered = false;
      vm.auto_dist.allow_if_client_not_respond = false;
      if (vm.option_not_counting === '1') {
        vm.auto_dist.allow_if_answered = true;
        vm.auto_dist.allow_if_client_not_respond = false;
      } else if (vm.option_not_counting === '2') {
        vm.auto_dist.allow_if_answered = false;
        vm.auto_dist.allow_if_client_not_respond = true;
      }
    }

    function save () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.metadata = data;
          if (vm.auto_dist.hasOwnProperty('enabled') && vm.auto_dist.enabled &&
                        (!vm.auto_dist.chat_per_user || vm.auto_dist.chat_per_user <= 0)) {
            NotificationService.warningHandler(null, 'Informe qual o número máximo de atendimentos por operador.');
            return false;
          }
          if (vm.metadata.hasOwnProperty('attendances') && vm.metadata.attendances.hasOwnProperty('time_waiting_client_to_busy_client') &&
                        !vm.metadata.attendances.time_waiting_client_to_busy_client && vm.option_not_counting === '2') {
            NotificationService.warningHandler(null, 'Esta opção só será liberada quando o tempo de espera estiver configurado na tela de regras de atendimento.');
            return false;
          }
          verifyOptionNotCounting();

          if (vm.auto_dist.enabled && vm.metadata.triage != $rootScope.TriageModes.MANAGER) {
            vm.metadata.triage = $rootScope.TriageModes.MANAGER
            CompanyService.saveMetadata({ id: vm.company_id }, vm.metadata);
          }

          if (vm.auto_dist.id) {
            // Update
            AutomaticDistributionService
              .update({}, { data: vm.auto_dist, company_id: vm.company_id })
              .$promise
              .then(function (data) {
                NotificationService.successHandler(data, data.message);
                $rootScope.automatic_distribution = angular.copy(vm.auto_dist);
              })
              .catch(function () {
                NotificationService.errorHandler(null, 'Erro ao atualizar configurações da distribuição.')
                return false;
              });
          } else {
            // Create
            vm.auto_dist['company_id'] = vm.company_id;
            AutomaticDistributionService
              .create({}, { data: vm.auto_dist })
              .$promise
              .then(function (data) {
                NotificationService.successHandler(data, data.message);
                $rootScope.automatic_distribution = angular.copy(vm.auto_dist);
                if (data.success) {
                  $state.reload();
                }
              })
              .catch(function () {
                NotificationService.errorHandler(null, 'Erro ao salvar configurações da distribuição.')
                return false;
              });
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(null, 'Erro ao salvar configurações da distribuição.')
          return false;
        });
    }
  }
})();
